module.exports = __webpack_public_path__ + "img/urgent_dark.61bbe1fc.svg";